var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('el-tree',{attrs:{"highlight-current":true,"data":_vm.treeData,"node-key":"id","empty-text":"暂无章节，请点击右上角更换条件！","props":_vm.defaultProps,"accordion":""},on:{"node-click":_vm.handleNodeClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }